(function ($, global, GsBase) {
	'use strict';

	var PageNavigationUtil = {
		init: function(pageIdx, rowsPerPage, pageRange, totalCnt ){
			var _this = this;
			_this.rowsPerPage = rowsPerPage;
			_this.totalCnt = totalCnt;
			_this.pageIdx = pageIdx;			

			//전체 페이지수
			var totalPage = Math.ceil(totalCnt/rowsPerPage) || 1;
			_this.totalPage = totalPage;

			//페이징 절반 범위
			var pageSemiRange = Math.floor(pageRange / 2);
			//시작 범위
			var pageStart = pageIdx - pageSemiRange > 0 ? pageIdx - pageSemiRange + 1 : 1;
			if( totalPage <= 10 ) pageStart = 1;
			
			//페이지 범위가 담긴 배열
			var pageRangeArray = new Array;

			for(var i = pageStart-1, j=0; j < pageRange && i < totalPage ; i++, j++){
				pageRangeArray[j] = i + 1;
			}

			//이전 범위
			var prevRange = pageRangeArray[0] - pageSemiRange > 1 ? pageRangeArray[0] - (pageSemiRange + 1) : 1;
			//다음 범위
			var nextRange = pageRangeArray[pageRangeArray.length - 1] + pageSemiRange < totalPage ? pageRangeArray[pageRangeArray.length - 1] + pageSemiRange : totalPage;
			if( pageIdx < 5 && totalPage > 10 ){
				nextRange = pageIdx + 10;
			}

			//페이징 템플릿
			var $template = $('<div class="paginate">');

			//이전 범위 요소 추가
			if (totalPage > 10 && prevRange !== pageRangeArray[0]) {
				$template.append('<a data-index="' + 1 + '" class="first btn_arrow">처음으로</a>');
				$template.append('<a data-index="' + prevRange + '" class="prev btn_arrow">이전으로</a>');
			}

			//페이징 요소 추가
			$.each(pageRangeArray, function(index, item) {
				if (item !== pageIdx) {
					$template.append('<a data-index="' + item + '" class="num">' + item + '</a>');
				}
				else {
					$template.append('<a data-index="' + item + '" class="num on">' + item + '</a>');
				}
			});

			//다음 범위 요소 추가
			if (nextRange !== pageRangeArray[pageRangeArray.length - 1]) {
				$template.append('<a data-index="' + nextRange + '" class="next btn_arrow">다음으로</a>');
				$template.append('<a data-index="' + totalPage + '" class="last btn_arrow">마지막으로</a>');
			}
			

			//템플릿 렌더링
			if( totalCnt > 0 ){
				$('#pageNavigation').html($template);
			}	
		},
		getParams: function(){
			var params={};
			window.location.search
  			.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str,key,value) {
    				params[key] = value;
  			});
			return params;
		},
		strigifyParam: function(param){
			var resultArr = [];
			for( var key in param ){
				var str = key+"="+param[key];
				resultArr.push(str);
			}

			return resultArr.join("&");
		},
		attachEvent: function(fncOnClick){
			var _this = this;
			_this.fncOnClick = fncOnClick;
			
			//동적으로 검색 조건 파라메터를 생성해서 페이지 이동
			$('#pageNavigation').on('click', '[data-index]', function () {
				
				var $this = $(this);
				//페이지 인덱스
				var index = $this.data('index');
				_this.pageIdx = index;			
				
				if( typeof Filter != "undefined" ) Filter.setPageNumber(index);
				
				if( typeof _this.fncOnClick == 'function' ){
					_this.fncOnClick();
				} else {
					HistoryManager.changeHash();
				}
			});
		}
	};

	//현재 페이지 엔트리 JSON 데이터
	//var conditionData ="";
	var conditionData =   ( $('#condition-data').html() ) ? $.parseJSON($('#condition-data').html()) : {};
	
	//현재 페이지
	if( conditionData && conditionData.jbpPrmmSearch ){
	
		var pageIdx = conditionData.jbpPrmmSearch.pageNumber;
		//페이지당 아이템수
		var rowsPerPage = conditionData.jbpPrmmSearch.pagePrdSize || 48;
		//페이지범위
		var pageRange = conditionData.jbpPrmmSearch.pageRange || 10;
		//전체 아이템수
		var totalCnt = conditionData.totalCnt;

		PageNavigationUtil.init(pageIdx, rowsPerPage, pageRange, totalCnt);
		PageNavigationUtil.attachEvent();
	}
	
	window.PageNavigationUtil = PageNavigationUtil;

}) (jQuery, window, window.GsBase = window.GsBase || {});


